import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import DealerLocation from './DealerLocation';

import { ExternallyArrangedDescription_item$key } from './__generated__/ExternallyArrangedDescription_item.graphql';

type Props = {
    item: ExternallyArrangedDescription_item$key | null;
};

const ExternallyArrangedDescription: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment ExternallyArrangedDescription_item on Item {
                ...DealerLocation_item
                vertical
            }
        `,
        itemRef
    );
    return (
        <span>
            <DealerLocation item={item} />{' '}
            <FormattedMessage
                id="checkout.ExternallyArrangedDescription.description"
                defaultMessage="After your order is confirmed, the {vertical, select, art {gallery} other {seller}} will contact you with the details that you will need to share with your shipper of choice."
                values={{ vertical: item?.vertical }}
            />
        </span>
    );
};

export default ExternallyArrangedDescription;
